import React, { useState } from 'react';
import Typography from '../../components/Typography/Typography';
import styles from './style.module.css'
import { CartItem } from '../../components/CartItem';
import { shoe } from '../../assets/images';
// import FlatButtons from '../../components/FlatButton/FlatButton';
// import { InputField } from '../../components/InputField';
import { useParams } from 'react-router-dom';

const BuyerOrderIdPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    // const navigate = useNavigate();

    // const goToCheckOut = () => {
    //     navigate("/buyer-checkout")
    // }

    // const [discountCode, setDiscountCode] = useState("");
    // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setDiscountCode(e.target.value);
    // }

    const cartItem = [
        {
            id: 1,
            name: "Wireless Bluetooth Headphones",
            category: "Electronics",
            stockNumber: 7,
            colour: "Black",
            price: 89.99,
            image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&h=200&fit=crop&crop=center",
            quantity: 1,
        },
        {
            id: 2,
            name: "Smart Watch",
            category: "Electronics",
            stockNumber: 8,
            colour: "Silver",
            price: 120.0,
            image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=200&h=200&fit=crop&crop=center",
            quantity: 2,
        },
        {
            id: 3,
            name: "Ankle High Boots",
            category: "Shoe",
            stockNumber: 7,
            colour: "Black",
            price: 999.29,
            image: `${shoe}`,
            quantity: 1,
        },
        {
            id: 4,
            name: "Running Shoes",
            category: "Footwear",
            stockNumber: 4,
            colour: "Blue",
            price: 75.50,
            image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
            quantity: 1,
        }
    ];

    const steps = [
        { id: 1, title: "Processed", label: "Confirmed", date: "02-04-2025", status: "active" },
        { id: 2, title: "Shipping", label: "Shipped", date: "16-04-2025", status: "pending" },
        { id: 3, title: "Delivered", label: "Arriving", date: "20-04-2025", status: "pending" },
    ];

    return (
        <div className={styles.container}>

            <div className={styles.moblieProgressView}>
                {steps.map((step, index) => (
                    <div className={styles.progressContainer}>
                        <div className={styles.progressIcon}>

                            <div className={styles.lineContainer}>
                                {index > 0 && (
                                    <div className={`${styles.line} ${styles[`${step.status}Line`]}`}>

                                    </div>
                                )}
                            </div>

                            <div>
                                <Typography
                                    className={`${styles.progressIconText} ${styles[`${step.status}Text`]}`}
                                >
                                    {step.id}
                                </Typography>
                            </div>

                            <div>

                                <div className={`${styles.statusPic} ${styles[`${step.status}Pic`]}`}>

                                    {step.title === "Processed" ? (
                                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 36C2.9 36 1.95867 35.6087 1.176 34.826C0.393333 34.0433 0.00133333 33.1013 0 32V7.05001C0 6.58334 0.0753332 6.13334 0.226 5.70001C0.376666 5.26668 0.601333 4.86668 0.9 4.50001L3.4 1.45001C3.76667 0.983344 4.22467 0.624677 4.774 0.374011C5.32333 0.123344 5.89867 -0.00132275 6.5 1.0582e-05H29.5C30.1 1.0582e-05 30.6753 0.125344 31.226 0.376011C31.7767 0.626677 32.2347 0.984677 32.6 1.45001L35.1 4.50001C35.4 4.86668 35.6253 5.26668 35.776 5.70001C35.9267 6.13334 36.0013 6.58334 36 7.05001V32C36 33.1 35.6087 34.042 34.826 34.826C34.0433 35.61 33.1013 36.0013 32 36H4ZM4.8 6.00001H31.2L29.5 4.00001H6.5L4.8 6.00001ZM26 10H10V22.75C10 23.5167 10.3167 24.092 10.95 24.476C11.5833 24.86 12.2333 24.8847 12.9 24.55L18 22L23.1 24.55C23.7667 24.8833 24.4167 24.858 25.05 24.474C25.6833 24.09 26 23.5153 26 22.75V10Z" fill={`${step.status === "active" ? "black" : "#8B909A"}`} />
                                        </svg>
                                    ) : step.title === "Shipping" ? (
                                        <svg width="48" height="36" viewBox="0 0 48 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.8 5.125C4.8 2.50508 6.9525 0.375 9.6 0.375H31.2C33.8475 0.375 36 2.50508 36 5.125V7.5H39.8025C41.0775 7.5 42.3 7.99727 43.2 8.88789L46.5975 12.25C47.4975 13.1406 48 14.3504 48 15.6121V26.5C48 29.1199 45.8475 31.25 43.2 31.25H42.9525C42.1725 33.9887 39.6225 36 36.6 36C33.5775 36 31.035 33.9887 30.2475 31.25H22.5525C21.7725 33.9887 19.2225 36 16.2 36C13.1775 36 10.635 33.9887 9.8475 31.25H9.6C6.9525 31.25 4.8 29.1199 4.8 26.5V22.9375H1.8C0.8025 22.9375 0 22.1434 0 21.1562C0 20.1691 0.8025 19.375 1.8 19.375H10.2C11.1975 19.375 12 18.5809 12 17.5938C12 16.6066 11.1975 15.8125 10.2 15.8125H1.8C0.8025 15.8125 0 15.0184 0 14.0312C0 13.0441 0.8025 12.25 1.8 12.25H15C15.9975 12.25 16.8 11.4559 16.8 10.4688C16.8 9.48164 15.9975 8.6875 15 8.6875H1.8C0.8025 8.6875 0 7.89336 0 6.90625C0 5.91914 0.8025 5.125 1.8 5.125H4.8ZM43.2 19.375V15.6121L39.8025 12.25H36V19.375H43.2ZM19.2 29.4688C19.2 28.6814 18.8839 27.9263 18.3213 27.3695C17.7587 26.8128 16.9956 26.5 16.2 26.5C15.4044 26.5 14.6413 26.8128 14.0787 27.3695C13.5161 27.9263 13.2 28.6814 13.2 29.4688C13.2 30.2561 13.5161 31.0112 14.0787 31.568C14.6413 32.1247 15.4044 32.4375 16.2 32.4375C16.9956 32.4375 17.7587 32.1247 18.3213 31.568C18.8839 31.0112 19.2 30.2561 19.2 29.4688ZM36.6 32.4375C37.3957 32.4375 38.1587 32.1247 38.7213 31.568C39.2839 31.0112 39.6 30.2561 39.6 29.4688C39.6 28.6814 39.2839 27.9263 38.7213 27.3695C38.1587 26.8128 37.3957 26.5 36.6 26.5C35.8044 26.5 35.0413 26.8128 34.4787 27.3695C33.9161 27.9263 33.6 28.6814 33.6 29.4688C33.6 30.2561 33.9161 31.0112 34.4787 31.568C35.0413 32.1247 35.8044 32.4375 36.6 32.4375Z" fill={`${step.status === "active" ? "black" : "#8B909A"}`} />
                                        </svg>
                                    ) : step.title === "Delivered" ? (
                                        <svg width="40" height="38" viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 0C5 0 4.2 0.4 3.6 1.2L1 4.4C0.4 5.2 0 6 0 7V32C0 34.2 1.8 36 4 36H20.6C20.2 34.8 20 33.4 20 32C20 25.4 25.4 20 32 20C33.4 20 34.8 20.2 36 20.6V7C36 6 35.6 5.2 35 4.4L32.2 1C31.8 0.4 31 0 30 0H6ZM5.8 2H29.8L31.6 4H4.2L5.8 2ZM6 24H18V30H6V24ZM36.6 25.6L29.4 32.8L26.2 29.6L24 32L29.6 38L39.2 28.4L36.6 25.6Z" fill={`${step.status === "active" ? "black" : "#8B909A"}`} />
                                        </svg>
                                    ) : (
                                        <span>❓</span> // Fallback (in case of unexpected value)
                                    )}

                                </div>

                            </div>

                            <div>
                                <Typography
                                    className={`${styles.progressIconText} ${styles[`${step.status}Text`]}`}
                                >
                                    {step.title}
                                </Typography>
                            </div>

                        </div>

                        <div className={styles.confirmContainer}>
                            <div>
                                <Typography
                                    className={styles.statusText}
                                >
                                    {step.label}
                                </Typography>
                                <Typography
                                    className={styles.statusDate}
                                >
                                    {step.date}
                                </Typography>
                            </div>
                        </div>

                    </div>
                ))}
            </div>

            {/* Left Section - Cart */}
            <div className={styles.cartContainer}>
                <div className={styles.cart}>
                    <Typography className={styles.cartText}>
                        My order #{id}
                    </Typography>
                </div>

                <div>
                    {cartItem.map((item) => (
                        <CartItem
                            key={item.id}
                            id={item.id}
                            name={item.name}
                            category={item.category}
                            stockNumber={item.stockNumber}
                            colour={item.colour}
                            price={item.price}
                            image={item.image}
                            initialQuantity={item.quantity}
                        />
                    ))}
                </div>

                <hr className={styles.horizontal} />

                <div className={styles.detailedSummary}>
                    <div className={styles.detailedSummaryItem}>
                        <Typography variant='heading6' className={styles.sub}>Subtotal</Typography>
                        <Typography className={styles.subAmount}>$8598549</Typography>
                    </div>

                    <div className={styles.detailedSummaryItem}>
                        <Typography variant='heading6' className={styles.sub}>Discount</Typography>
                        <Typography className={styles.discountAmount}>$3098547</Typography>
                    </div>

                    <div className={styles.detailedSummaryItem}>
                        <Typography variant='heading6' className={styles.sub}>Total</Typography>
                        <Typography className={styles.subAmount}>$748739</Typography>
                    </div>
                </div>
            </div>

            {/* Right Section - Order Progress */}
            <div className={styles.summaryContainer}>
                <div className={styles.summary}>
                    <Typography className={styles.summaryText}>
                        Order Progress
                    </Typography>
                </div>

                {steps.map((step, index) => (
                    <div className={styles.progressContainer}>
                        <div className={styles.progressIcon}>

                            <div className={styles.lineContainer}>
                                {index > 0 && (
                                    <div className={`${styles.line} ${styles[`${step.status}Line`]}`}>

                                    </div>
                                )}
                            </div>

                            <div>
                                <Typography
                                    className={`${styles.progressIconText} ${styles[`${step.status}Text`]}`}
                                >
                                    {step.id}
                                </Typography>
                            </div>

                            <div>

                                <div className={`${styles.statusPic} ${styles[`${step.status}Pic`]}`}>

                                    {step.title === "Processed" ? (
                                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 36C2.9 36 1.95867 35.6087 1.176 34.826C0.393333 34.0433 0.00133333 33.1013 0 32V7.05001C0 6.58334 0.0753332 6.13334 0.226 5.70001C0.376666 5.26668 0.601333 4.86668 0.9 4.50001L3.4 1.45001C3.76667 0.983344 4.22467 0.624677 4.774 0.374011C5.32333 0.123344 5.89867 -0.00132275 6.5 1.0582e-05H29.5C30.1 1.0582e-05 30.6753 0.125344 31.226 0.376011C31.7767 0.626677 32.2347 0.984677 32.6 1.45001L35.1 4.50001C35.4 4.86668 35.6253 5.26668 35.776 5.70001C35.9267 6.13334 36.0013 6.58334 36 7.05001V32C36 33.1 35.6087 34.042 34.826 34.826C34.0433 35.61 33.1013 36.0013 32 36H4ZM4.8 6.00001H31.2L29.5 4.00001H6.5L4.8 6.00001ZM26 10H10V22.75C10 23.5167 10.3167 24.092 10.95 24.476C11.5833 24.86 12.2333 24.8847 12.9 24.55L18 22L23.1 24.55C23.7667 24.8833 24.4167 24.858 25.05 24.474C25.6833 24.09 26 23.5153 26 22.75V10Z" fill={`${step.status === "active" ? "black" : "#8B909A"}`} />
                                        </svg>
                                    ) : step.title === "Shipping" ? (
                                        <svg width="48" height="36" viewBox="0 0 48 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.8 5.125C4.8 2.50508 6.9525 0.375 9.6 0.375H31.2C33.8475 0.375 36 2.50508 36 5.125V7.5H39.8025C41.0775 7.5 42.3 7.99727 43.2 8.88789L46.5975 12.25C47.4975 13.1406 48 14.3504 48 15.6121V26.5C48 29.1199 45.8475 31.25 43.2 31.25H42.9525C42.1725 33.9887 39.6225 36 36.6 36C33.5775 36 31.035 33.9887 30.2475 31.25H22.5525C21.7725 33.9887 19.2225 36 16.2 36C13.1775 36 10.635 33.9887 9.8475 31.25H9.6C6.9525 31.25 4.8 29.1199 4.8 26.5V22.9375H1.8C0.8025 22.9375 0 22.1434 0 21.1562C0 20.1691 0.8025 19.375 1.8 19.375H10.2C11.1975 19.375 12 18.5809 12 17.5938C12 16.6066 11.1975 15.8125 10.2 15.8125H1.8C0.8025 15.8125 0 15.0184 0 14.0312C0 13.0441 0.8025 12.25 1.8 12.25H15C15.9975 12.25 16.8 11.4559 16.8 10.4688C16.8 9.48164 15.9975 8.6875 15 8.6875H1.8C0.8025 8.6875 0 7.89336 0 6.90625C0 5.91914 0.8025 5.125 1.8 5.125H4.8ZM43.2 19.375V15.6121L39.8025 12.25H36V19.375H43.2ZM19.2 29.4688C19.2 28.6814 18.8839 27.9263 18.3213 27.3695C17.7587 26.8128 16.9956 26.5 16.2 26.5C15.4044 26.5 14.6413 26.8128 14.0787 27.3695C13.5161 27.9263 13.2 28.6814 13.2 29.4688C13.2 30.2561 13.5161 31.0112 14.0787 31.568C14.6413 32.1247 15.4044 32.4375 16.2 32.4375C16.9956 32.4375 17.7587 32.1247 18.3213 31.568C18.8839 31.0112 19.2 30.2561 19.2 29.4688ZM36.6 32.4375C37.3957 32.4375 38.1587 32.1247 38.7213 31.568C39.2839 31.0112 39.6 30.2561 39.6 29.4688C39.6 28.6814 39.2839 27.9263 38.7213 27.3695C38.1587 26.8128 37.3957 26.5 36.6 26.5C35.8044 26.5 35.0413 26.8128 34.4787 27.3695C33.9161 27.9263 33.6 28.6814 33.6 29.4688C33.6 30.2561 33.9161 31.0112 34.4787 31.568C35.0413 32.1247 35.8044 32.4375 36.6 32.4375Z" fill={`${step.status === "active" ? "black" : "#8B909A"}`} />
                                        </svg>
                                    ) : step.title === "Delivered" ? (
                                        <svg width="40" height="38" viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 0C5 0 4.2 0.4 3.6 1.2L1 4.4C0.4 5.2 0 6 0 7V32C0 34.2 1.8 36 4 36H20.6C20.2 34.8 20 33.4 20 32C20 25.4 25.4 20 32 20C33.4 20 34.8 20.2 36 20.6V7C36 6 35.6 5.2 35 4.4L32.2 1C31.8 0.4 31 0 30 0H6ZM5.8 2H29.8L31.6 4H4.2L5.8 2ZM6 24H18V30H6V24ZM36.6 25.6L29.4 32.8L26.2 29.6L24 32L29.6 38L39.2 28.4L36.6 25.6Z" fill={`${step.status === "active" ? "black" : "#8B909A"}`} />
                                        </svg>
                                    ) : (
                                        <span>❓</span> // Fallback (in case of unexpected value)
                                    )}

                                </div>

                            </div>

                            <div>
                                <Typography
                                    className={`${styles.progressIconText} ${styles[`${step.status}Text`]}`}
                                >
                                    {step.title}
                                </Typography>
                            </div>

                        </div>

                        <div className={styles.confirmContainer}>
                            <div>
                                <Typography
                                    className={styles.statusText}
                                >
                                    {step.label}
                                </Typography>
                                <Typography
                                    className={styles.statusDate}
                                >
                                    {step.date}
                                </Typography>
                            </div>
                        </div>

                    </div>
                ))}

            </div>

        </div>
    );
};

export default BuyerOrderIdPage;
